import { UTILS } from '@cms/tpl';
import { Tag } from 'antd';
import React from 'react';
const Status = {
  SHOW: [1, 'Hiển thị', <Tag color={UTILS.COLOR.GREEN}>Hiển thị</Tag>],
  HIDE: [2, 'Ẩn', <Tag color={UTILS.COLOR.YELLOW_ORANGE}>Ẩn</Tag>],
};
export default Status;
